import React from "react";
import styled from "styled-components";

const arrow = require("../images/arrow-right.svg");

const ProjectItem = ({ title, text, link }) => (
  <Wrapper href={link} target="_blank">
    <Information>
      <div>
        <Title>{title}</Title>
        <Text>{text}</Text>
      </div>
      <IconWrapper>
        <IconArrow src={arrow} />
      </IconWrapper>
    </Information>
  </Wrapper>
);

const IconArrow = styled.img`
  transition: 0.2s ease-out;
`;

let Wrapper = ({ children, href, target, ...props }) => (
  <a href={href} target={target} {...props}>
    {children}
  </a>
);

Wrapper = styled(Wrapper)`
  width: 100%;
  max-width: 350px;
  min-width: 200px;
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: 10px;
  box-shadow: 5px 5px 18px rgb(27, 5, 107, 0.1);
  transition: box-shadow 0.2s ease-out;
  cursor: pointer;
  &:hover {
    box-shadow: 5px 5px 18px rgb(27, 5, 107, 0.18);

    ${IconArrow} {
      transform: translateX(6px);
    }
  }
`;

const Information = styled.div`
  height: 100%;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Title = styled.div`
  margin-bottom: 0.75rem;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: ${({ theme }) => theme.colors.background};
`;

const Text = styled.div`
  margin-bottom: 1.5rem;
`;

const IconWrapper = styled.div`
  padding-right: 6px;
  text-align: right;
`;

export default ProjectItem;
